// extracted by mini-css-extract-plugin
export var background = "ambassadors-hero-module--background--4fd74";
export var container = "ambassadors-hero-module--container--fef64";
export var image = "ambassadors-hero-module--image--80d00";
export var section = "ambassadors-hero-module--section--03b0d";
export var text = "ambassadors-hero-module--text--c61b4";